import { useSelector, useDispatch } from "react-redux";
import {
  addNewArrival,
  getNewArrival,
  updateArrival,
  deleteArrival,
  setActiveArrivals,
  setRedirection,
  setOffset,
  setPage,
  setPerPage,
} from "../store/arrival";

function useArrival() {
  const dispatch = useDispatch();
  const check = useSelector((state) => state.arrival);

  const arrivalList = useSelector((state) => state.arrival.newArrivalList);
  const loading = useSelector((state) => state.arrival.loading);
  const activeArrivals = useSelector((state) => state.arrival.activeArrivals);
  const redirect = useSelector((state) => state.arrival.redirect);

  const page = useSelector((state) => state.arrival?.page);
  const perPage = useSelector((state) => state.arrival?.perPage);
  const offset = useSelector((state) => state.arrival?.offset);
 

  const setOffsetAction = (params) => dispatch(setOffset(params));
  const setPerPageAction = (params) => dispatch(setPerPage(params));
  const setPageAction = (params) => dispatch(setPage(params));

  const addNewArrivalInfo = (params) => dispatch(addNewArrival(params));
  const getNewArrivalInfo = (params) => dispatch(getNewArrival(params));
  const updateArrivalInfo = (params) => dispatch(updateArrival(params));
  const deleteArrivalInfo = (params) => dispatch(deleteArrival(params));
  const setActiveArrivalAction = (params) =>
    dispatch(setActiveArrivals(params));
  const setRedirectAction = (params) => dispatch(setRedirection(params));

  return {
    //action//
    addNewArrivalInfo,
    getNewArrivalInfo,
    updateArrivalInfo,
    deleteArrivalInfo,
    setActiveArrivalAction,
    setRedirectAction, 

    // actions
    setOffsetAction,
    setPerPageAction,
    setPageAction,

    //state//
    page,
    perPage,
    offset,

    loading,
    activeArrivals,
    addNewArrival,
    getNewArrival,
    arrivalList,
    updateArrival,
    deleteArrival,
    redirect,
  };
}
export default useArrival;
